import { useEffect, useState, forwardRef } from "react";

import placeHolder from "../../../assets/images/frenchtech_placeholder.jpg";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapScreen,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current.osInstance();
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id === idToCompare);
      const { viewport } = scrollbarInstance.elements();
      viewport.scrollTo({
        top: e.currentTarget.offsetTop,
        behavior: "smooth",
      });
    };

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
          document.body.classList.add("no-scroll");
          setMapScreen(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    //--- Create a list of icons composed of the type of activity the entity has
    const iconList = [];
    // for (const category of etablissement[Object.keys(filters)[1]]) {
    //   for (const cat of filters[Object.keys(filters)[1]].values) {
    //     if (category === cat.slug) {
    //       iconList.push(cat.icon);
    //     }
    //   }
    // }

    //     let typeComponent = [];
    //     for (const element of etablissement[Object.keys(filters)[1]]) {
    //       for (const filter of filters[Object.keys(filters)[1]].values) {

    //         if (element === filter.slug) {
    //          {typeComponent.push(<span style={{marginRight:'5px'}}>{element}</span>)}
    //         }
    //       }
    //     }

    // const typeComponent = etablissement[Object.keys(filters)[1]].map((item, index) => {
    //   for (const filter of filters[Object.keys(filters)[1]].values) {
    //     if (item === filter.slug) {
    //       return (
    //         <span key={index} style={{ marginRight: "5px" }}>
    //           {item}
    //         </span>
    //       );
    //     }
    //   }
    // });

    let colorsArray = [];
    //--- Create Array of colors looping on first filter key
    // for (const element of etablissement[Object.keys(filters)[0]]) {
    //   for (const filter of filters[Object.keys(filters)[0]].values) {
    //     if (element === filter.slug) {
    //       colorsArray.push(filter.color);
    //     }
    //   }
    // }

    //--- Create the color bands depending on the colors Array created above
    // const colorBands = colorsArray.map((color, index) => {
    //   return (
    //     <span
    //       key={color + index}
    //       style={{ display: "inline-block", width: "50px", height: "5px", backgroundColor: `${color}` }}
    //     ></span>
    //   );
    // });
    // console.log(etablissement?.town, etablissement?.prestation_loyer_mensuel_cc)
    return (
      <div
        className={`inst-item ${isSelected ? "active " : ""}d-flex`}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
      >
        <div className="inst-item__img-wrapper ">
          <img
            src={etablissement.image ? etablissement.image : placeHolder}
            alt={etablissement.name}
            width="70"
            height="70"
          />
          <div class="tags">
            {
              etablissement?.status ?
                <div class="tag white" data-tag={`${etablissement.status}`}>
                  <span class="tag-title-status">{etablissement.status}</span>
                </div>
                : <></>
            }
            {
              etablissement?.label ?
                <div class="tag white" data-tag={`${etablissement.label}`}>
                  <span class="tag-title-label">{etablissement.label}</span>
                </div>
                : <></>
            }

          </div>

        </div>
        <div className="d-flex flex-column">
          {/* <div className="d-flex inst-item__color-band ">{colorBands}</div> */}
          {/* <div className="pb-2 pr-3"> */}
          <div className="inst-item__data-wrapper">
            <div
              className={`inst-item__name `}
            >
              {etablissement.name}
            </div>
            <div className="inst-item__address">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 10C20 14.4183 12 22 12 22C12 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z" stroke="#FFFFFF" stroke-width="1.5" />
                <path d="M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {etablissement.town[0]}</div>
            <div className="inst-item-data-row">
              {
                etablissement?.housing_type && etablissement.housing_type.length > 0 ? (<div className="inst-item__type-wrapper">
                  {
                    etablissement.housing_type.split(', ').map((item) => (
                      <div className="inst-item__type" key={item}>{item}</div>
                    ))
                  }
                </div>
                ) :
                  (<></>)
              }
              {
                etablissement?.price && etablissement?.price.length !== 0 && etablissement.price[0] ?
                  (
                    <div className="inst-item__prix">
                      à partir de
                      <span>{etablissement.price[0]} €</span>
                    </div>
                  )
                  :
                  (
                    <div className="inst-item__prix">
                      Prix non renseigné
                    </div>
                  )
              }

            </div>
            {/* <div className="inst-item__svg-list">{typeComponent}</div> */}
            <div class="card-link">
              <a
                href={`${etablissement.url}`} target="_blank"
                class="btn btn-inverted btn-purple">
                <span class="icon-gdh-forward"></span>
                <span>découvrir le programme</span>
              </a>
            </div>
          </div>
        </div>
      </div >
    );
  }
);

export default InstitutionItem;
